import { Link } from "react-router-dom"
import { ANNOUNCEMENT, EDUCATIONSYSTEM, FAQ, GALLERYINFOGRAFIS, GALLERYVIDEO, LMS, LPTK, NEWS, NEWSDETAIL, UKMPPG } from "../../routes/routes_name"
import useLandingPage from "./useLandingPage"
import DOMPurify from "dompurify";
import LimitedText from "../../components/limited_text";


const LandingPage = () => {
    const {
        data,
        numFaq,
        dataFaq,
        sliders,
        ppgSteps,
        dataVideo,
        isLoading,
        dataGallery,
        isLoadingFaq,
        isLoadingVideo,
        dataInfografis,
        isShowRegButton,
        isLoadingInfografis,
        handleSelectFaq,
        getThumbnailImage,
        handleShowFullStep,
        handleShowRegButton,
        handleMobileNavToggle,
        handleMobileSelectNavMenu,
        handleMobileToggleNavMenu,
    } = useLandingPage()
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
                    <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <nav id="navmenu" className="navmenu">
                        <ul>
                            <li><a onClick={handleMobileSelectNavMenu} href="#">Beranda</a></li>
                            <li className="dropdown"><a onClick={(e) => handleMobileToggleNavMenu(e, "news")} className="news-toggle" href="#"><span>Berita</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                                <ul className="news-toggle-list">
                                    <li><a onClick={handleMobileSelectNavMenu} href="#news">Berita PPG</a></li>
                                    <li><a onClick={handleMobileSelectNavMenu} href={ANNOUNCEMENT}>Pengumuman</a></li>
                                </ul>
                            </li>
                            <li className="dropdown"><a onClick={(e) => handleMobileToggleNavMenu(e, "provision")} href="#" className="provision-toggle"><span>Ketentuan</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                                <ul className="provision-toggle-list">
                                    <li><a onClick={handleMobileSelectNavMenu} href="#provision">Persyaratan & Kriteria</a></li>
                                    <li><a onClick={handleMobileSelectNavMenu} href="#ppg-steps">Tahapan PPG Daljab</a></li>
                                    <li><a onClick={handleMobileSelectNavMenu} href="#registration-link">Link Pendaftaran</a></li>
                                </ul>
                            </li>
                            <li><a onClick={handleMobileSelectNavMenu} href="#education-system">Sistem Pembelajaran</a></li>
                            <li><a onClick={handleMobileSelectNavMenu} href="https://app.ppgkemenag.com/">LMS</a></li>
                            <li><a onClick={handleMobileSelectNavMenu} href={UKMPPG}>UKM PPG</a></li>
                            <li><a onClick={handleMobileSelectNavMenu} href={LPTK}>Lapor Diri LPTK</a></li>
                            <li><a onClick={handleMobileSelectNavMenu} href="#gallery">Galeri</a></li>
                            <li><a onClick={handleMobileSelectNavMenu} href="#faq">FAQ</a></li>
                        </ul>
                        <i onClick={handleMobileNavToggle} className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                    </nav>
                </div>
            </header>
            <main className="main">
                {/* Hero Section */}
                <section id="hero" className="hero section">
                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row align-items-center">
                            <div className="col-lg-4">
                                <div className="hero-content" data-aos="fade-up" data-aos-delay="200">
                                    <h1>
                                        Pendidikan Profesi Guru Dalam Jabatan<br />
                                        <span className="accent-text">Kementerian Agama RI</span>
                                    </h1>
                                    <p style={{ fontSize: "15px" }}>
                                        PPG Dalam Jabatan Transformasi+  di Kementerian Agama yang mengusung semangat
                                        rekognisi terhadap kapasitas dan kompetensi guru dalam jabatan yang belum tersertifikasi.
                                        PPG Dalam Jabatan Transformasi + ini diperuntukkan bagi guru madrasah serta guru pendidikan agama
                                        Islam, Kristen, Katolik, Hindu, Buddha, dan Khonghucu yang telah memenuhi persyaratan
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div data-aos="fade-up" data-aos-delay="300">
                                    <div id="carouselSliderAutoplaying" className="carousel slide carousel-fade mb-5" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            {
                                                sliders.map((d, i) => (
                                                    <div key={i} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                                                        <img src={d.img} className="d-block w-100 rounded-4" />
                                                        <div className="carousel-caption d-none d-md-block">
                                                            <h5>{d.label}</h5>
                                                            <p>{d.description}</p>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselSliderAutoplaying"
                                            data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#carouselSliderAutoplaying"
                                            data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                {/* End Hero Section */}

                {/* News Section */}
                <section id="news" className="news section">
                    <div className="container section-title" data-aos="fade-up" data-aos-delay="100">
                        <h2>Berita</h2>
                        <p>Berikut merupakan Berita terkait Pendidikan Profesi Guru (PPG) Kementerian Agama RI</p>
                        <Link to={NEWS} className="btn btn-primary my-4">Lihat Semua <i className="bi bi-chevron-right"></i> </Link>
                    </div>
                    <div className="container" data-aos="fade-up" data-aos-delay="200">
                        <div className="row g-3">
                            {
                                isLoading ? <p>Loading...</p> : data.map((d, i) => {
                                    return (
                                        <div key={i} className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                            <div className="card w-100" style={{ width: "18rem" }}>
                                                <img src={d.image.thumbnail} className="card-img-top" alt="..." />
                                                <div className="card-body">
                                                    <h5 className="card-title">{d.title}</h5>
                                                    {/* <p className="card-text">{d.preview}</p> */}
                                                    <div className="card-text"
                                                        dangerouslySetInnerHTML={{
                                                            __html: DOMPurify.sanitize(LimitedText({ text: d.preview, limit: 50 })),
                                                        }}
                                                    />
                                                    <Link to={`${NEWSDETAIL}/${d.code}/${d.category.slug}`} className="read-more">Selengkapnya <i className="bi bi-arrow-right"></i> </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>
                {/* End News Section */}

                {/* Provision Section */}
                <section id="provision" className="about features-cards section">
                    <div className="container section-title" data-aos="fade-up" data-aos-delay="100">
                        <h2>Ketentuan</h2>
                        <p>Berikut merupakan ketentuan terkait Pendidikan Profesi Guru (PPG) Kementerian Agama RI</p>
                        <div className="row gy-4 my-2 align-items-center">
                            <div className="col-xl-7 col-md-12" data-aos="zoom-in" data-aos-delay="200">
                                <div className="feature-box blue" style={{ flexDirection: "column", alignItems: "start" }}>
                                    <i className="bi bi-award"></i>
                                    <h4>Persyaratan & Kriteria</h4>
                                    <p>Berikut adalah persyaratan & kriteria Pendidikan Profesi Guru (PPG) Kementerian Agama RI</p>
                                    <div className="row feature-list-wrapper">
                                        <div className="col-md-6">
                                            <ul className="feature-list">
                                                <li><i className="bi bi-check-circle-fill"></i> Terdaftar aktif sebagai guru dalam satminkal yang terdata dalam sistem pendataan Kementerian Agama;</li>
                                                <li><i className="bi bi-check-circle-fill"></i> Guru yang diangkat paling lambat tanggal 30 Juni 2023 dan terdata aktif Tahun Ajaran 2023/2024;</li>
                                                <li><i className="bi bi-check-circle-fill"></i> Memiliki kualifikasi akademik minimal S-1/D-IV yang sesuai dengan mapel PPG Dalam Jabatan;</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="feature-list">
                                                <li><i className="bi bi-check-circle-fill"></i> Belum mencapai batas usia pensiun guru berdasarkan ketentuan peraturan perundang-undangan;</li>
                                                <li><i className="bi bi-check-circle-fill"></i> Belum memiliki sertifikat pendidik; dan</li>
                                                <li><i className="bi bi-check-circle-fill"></i> Sehat jasmani yang dibuktikan dengan surat keterangan sehat jasmani dari rumah sakit pemerintah/puskesmas/pusat layanan kesehatan lainnya.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5" data-aos="fade-up" data-aos-delay="300">
                                <div className="image-wrapper">
                                    <div className="images position-relative" data-aos="zoom-out" data-aos-delay="400">
                                        <img src="assets/img/provision/provision_1.jpeg" alt="Business Meeting" className="img-fluid main-image rounded-4" />
                                        <img src="assets/img/provision/provision_2.jpeg" alt="Team Discussion" className="img-fluid small-image rounded-4" />
                                    </div>
                                    {/* <div className="experience-badge floating">
                                        <h3>PPG <span>Dalam Jabatan</span></h3>
                                        <p>Kementerian Agama RI</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Provision Section */}

                {/* PPG Steps Section */}
                <section id="ppg-steps" className="ppg-steps section">
                    <div className="container section-title" data-aos="fade-up" data-aos-delay="100">
                        <h2>Tahapan PPG Daljab</h2>
                        <p>Berikut merupakan Tahapan PPG Daljab Kementerian Agama RI</p>
                        <div className="row my-5 justify-content-center">
                            {
                                ppgSteps.map((d, i) => (
                                    <div key={i} className="col-xl-4 col-lg-4 col-md-6 col-sm-12" data-aos="fade-up" data-aos-delay="200">
                                        <div className="ppg-steps-col">
                                            <h4><div className="ppg-steps-icon-number">{i + 1}</div> {d.title}</h4>
                                            <div className="ppg-steps-content">
                                                {
                                                    d.isShow ?
                                                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(d.detail) }}></p> :
                                                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(LimitedText({ text: d.detail, limit: 200 })) }}></p>
                                                }
                                            </div>
                                            <Link onClick={() => {
                                                handleShowFullStep(i)
                                            }}>{d.isShow ? "Read Less" : "Read More"}</Link>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </section>
                {/* End PPG Steps Section */}

                {/* Registration Link Section */}
                <section id="registration-link" className="call-to-action section">
                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row content justify-content-center align-items-center position-relative">
                            <div className="col-lg-8 mx-auto text-center">
                                <h2 className="display-4" style={{ fontWeight: "300", }}>Link Pendaftaran</h2>
                                <p className="mb-4">Daftar sekarang melalui link dengan cara menekan tombol di bawah ini</p>
                                <button onClick={() => handleShowRegButton()} className="btn btn-cta">Daftar Sekarang</button>
                                {
                                    isShowRegButton && (
                                        <div className="d-flex justify-content-center my-4" style={{ gap: "16px" }}>
                                            <Link rel="noreferrer" target="_blank" to={"https://emis.kemenag.go.id"} className="btn btn-cta">EMIS</Link>
                                            <Link rel="noreferrer" target="_blank" to={"https://siagapendis.kemenag.go.id/login"} className="btn btn-cta">SIAGA</Link>
                                            <Link rel="noreferrer" target="_blank" to={"https://simpatika.kemenag.go.id"} className="btn btn-cta">SIMPATIKA</Link>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Registration Link Section */}

                {/* Education System Section */}
                <section id="education-system" className="education-system services section">
                    <div className="container section-title" data-aos="fade-up" data-aos-delay="100">
                        <h2>Sistem Pembelajaran</h2>
                        <p>Berikut merupakan Sistem Pembelajaran terkait Pendidikan Profesi Guru (PPG) Kementerian Agama RI</p>
                        <div className="row my-5 reverse">
                            <div className="col-xl-6 col-lg-12 col-md-12" style={{ textAlign: "left" }} data-aos="fade-up" data-aos-delay="200">
                                <div className="service-card d-flex border">
                                    <div>
                                        <div>
                                            Secara umum, PPG Dalam Jabatan dilaksanakan mulai dari
                                            pendalaman materi sampai Uji Kompetensi Mahasiswa PPG (UKMPPG),
                                            dijelaskan sebagaimana berikut:
                                        </div>
                                        <div className="my-2">
                                            <ol style={{ marginLeft: "-1em" }}>
                                                <li>
                                                    Kegiatan Pendalaman Materi. Kegiatan pendalaman materi
                                                    dilakukan dalam bentuk:
                                                    <ul style={{ marginLeft: "-2em" }}>
                                                        <li><i className="bi bi-check"></i> Mengerjakan pretes modul;</li>
                                                        <li><i className="bi bi-check"></i> Mempelajari materi yang disajikan dalam modul secara mandiri dan terstruktur;</li>
                                                        <li><i className="bi bi-check"></i> Membuat ringkasan materi pada Modul Pedagogik dan profesional;</li>
                                                        <li><i className="bi bi-check"></i> Mengerjakan tes formatif atau tugas-tugas terstruktur; dan</li>
                                                        <li><i className="bi bi-check"></i> Mengerjakan tes akhir modul.</li>
                                                    </ul>
                                                </li>
                                            </ol>
                                        </div>
                                        <Link to={EDUCATIONSYSTEM} className="read-more"> Selengkapnya <i className="bi bi-arrow-right"></i></Link>
                                    </div>
                                </div>

                            </div>
                            <div className="col-xl-6 col-lg-12 col-md-12" data-aos="fade-up" data-aos-delay="200">
                                <img className="w-100 rounded-4 mb-4" src="/assets/img/jadwal_batch_1.jpeg" />
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Education System Section */}

                {/* Gallery Section */}
                <section id="gallery" className="gallery section">
                    <div className="container section-title" data-aos="fade-up" data-aos-delay="100">
                        <h2>Galeri</h2>
                        <p>Berikut merupakan data media tentang PPG Kementerian Agama RI</p>
                        <div className="row">
                            <div className="col-xl-8 col-lg-6 col-md-12 col-sm-12 gy-4">
                                <div className="gallery-header-col">
                                    <h3>Video</h3>
                                    <Link to={GALLERYVIDEO}>Lihat Semua</Link>
                                </div>
                                <div className="row p-3 border rounded-4 m-1" >
                                    {
                                        isLoadingVideo ? <div className="text-center">Loading...</div> :
                                            !dataVideo ? <div className="text-center">Data tidak ditemukan</div> :
                                                dataVideo.map((d, i) => {
                                                    const thumbnailImg = getThumbnailImage(d.file)
                                                    return (
                                                        <div key={i} className="col-xl-6 col-lg-6 col-md-6 col-sm-12 my-2" style={{ position: "relative", display: "inline-block" }}
                                                            data-aos="fade-up" data-aos-delay="200">
                                                            <a href={d.file} className="glightbox">
                                                                <img src={thumbnailImg} className="w-100 rounded-4" alt="" />
                                                                <div style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                }} >
                                                                    <button
                                                                        className="btn btn-primary btn-lg rounded-circle"
                                                                        style={{ width: '60px', height: '60px' }} >
                                                                        <i className="bi bi-play" style={{
                                                                            fontSize: "50px",
                                                                            position: "absolute",
                                                                            top: "-15%",
                                                                            left: "15%",
                                                                        }}></i>
                                                                    </button>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    )
                                                })
                                    }
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 gy-4">
                                <div className="gallery-header-col">
                                    <h3>Infografis</h3>
                                    <Link to={GALLERYINFOGRAFIS}>Lihat Semua</Link>
                                </div>
                                <div className="row p-3 border rounded-4 m-1">
                                    {
                                        isLoadingInfografis ? <div className="text-center">Loading...</div> :
                                            !dataInfografis ? <div className="text-center">Data tidak ditemukan</div> :
                                                <div id="carouselInfografisAutoplaying" className="carousel slide" data-bs-ride="carousel"
                                                    data-aos="fade-up" data-aos-delay="200">
                                                    <div className="carousel-inner">
                                                        {
                                                            dataInfografis.map((d, i) => {
                                                                return (
                                                                    <div key={i} className={`carousel-item ${i === 0 ? "active" : ""}`} >
                                                                        <a href={d.file} className="glightbox">
                                                                            <img src={d.file} className="d-block w-100 rounded-4" alt="" />
                                                                        </a>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselInfografisAutoplaying"
                                                        data-bs-slide="prev">
                                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                        <span className="visually-hidden">Previous</span>
                                                    </button>
                                                    <button className="carousel-control-next" type="button" data-bs-target="#carouselInfografisAutoplaying"
                                                        data-bs-slide="next">
                                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                        <span className="visually-hidden">Next</span>
                                                    </button>
                                                </div>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                {/* End Gallery Section */}

                {/* FAQ Section */}
                <section className="faq-9 faq section light-background" id="faq">
                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row">
                            <div className="col-lg-5 mb-4" data-aos="fade-up">
                                <h2 className="faq-title">Punya pertanyaan? Silahkan cek di FAQ</h2>
                                <p className="faq-description">Temukan jawaban atas pertanyaan yang sering diajukan di halaman FAQ kami. Kami telah merangkum berbagai informasi penting untuk membantu Anda memahami layanan, fitur, dan kebijakan kami dengan lebih baik. Jika Anda tidak menemukan jawaban yang Anda cari, jangan ragu untuk menghubungi tim support kami.</p>
                                <div className="faq-arrow d-flex align-items-end" data-aos="fade-up" data-aos-delay="200">
                                    <svg className="faq-arrow" width="200" height="211" viewBox="0 0 200 211" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M198.804 194.488C189.279 189.596 179.529 185.52 169.407 182.07L169.384 182.049C169.227 181.994 169.07 181.939 168.912 181.884C166.669 181.139 165.906 184.546 167.669 185.615C174.053 189.473 182.761 191.837 189.146 195.695C156.603 195.912 119.781 196.591 91.266 179.049C62.5221 161.368 48.1094 130.695 56.934 98.891C84.5539 98.7247 112.556 84.0176 129.508 62.667C136.396 53.9724 146.193 35.1448 129.773 30.2717C114.292 25.6624 93.7109 41.8875 83.1971 51.3147C70.1109 63.039 59.63 78.433 54.2039 95.0087C52.1221 94.9842 50.0776 94.8683 48.0703 94.6608C30.1803 92.8027 11.2197 83.6338 5.44902 65.1074C-1.88449 41.5699 14.4994 19.0183 27.9202 1.56641C28.6411 0.625793 27.2862 -0.561638 26.5419 0.358501C13.4588 16.4098 -0.221091 34.5242 0.896608 56.5659C1.8218 74.6941 14.221 87.9401 30.4121 94.2058C37.7076 97.0203 45.3454 98.5003 53.0334 98.8449C47.8679 117.532 49.2961 137.487 60.7729 155.283C87.7615 197.081 139.616 201.147 184.786 201.155L174.332 206.827C172.119 208.033 174.345 211.287 176.537 210.105C182.06 207.125 187.582 204.122 193.084 201.144C193.346 201.147 195.161 199.887 195.423 199.868C197.08 198.548 193.084 201.144 195.528 199.81C196.688 199.192 197.846 198.552 199.006 197.935C200.397 197.167 200.007 195.087 198.804 194.488ZM60.8213 88.0427C67.6894 72.648 78.8538 59.1566 92.1207 49.0388C98.8475 43.9065 106.334 39.2953 114.188 36.1439C117.295 34.8947 120.798 33.6609 124.168 33.635C134.365 33.5511 136.354 42.9911 132.638 51.031C120.47 77.4222 86.8639 93.9837 58.0983 94.9666C58.8971 92.6666 59.783 90.3603 60.8213 88.0427Z" fill="currentColor"></path>
                                    </svg>
                                    <div className="faq-link">
                                        <Link to={FAQ} className="btn btn-primary"><i className="bi bi-question-circle"></i> FAQ Selengkapnya</Link>
                                        {/* <Link to={"https://forms.gle/HuvXpMXiDy5MGKxs5"} className="btn btn-primary" rel="noreferrer" target="_blank"><i className="bi bi-headset"></i> Tanya Helpdesk</Link> */}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="300">
                                <div className="faq-container">
                                    {
                                        dataFaq && dataFaq.map((d, i) => {
                                            if (i > 4) {
                                                return <div key={i}></div>
                                            }
                                            return (
                                                <div key={i} className={`faq-item ${i === numFaq ? "faq-active" : ""}`} >
                                                    <h3 onClick={() => handleSelectFaq(i)}>{d.pertanyaan}</h3>
                                                    <div className="faq-content">
                                                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(d.jawaban) }}></p>
                                                    </div>
                                                    <i className="faq-toggle bi bi-chevron-right"></i>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* End FAQ Section */}


            </main>
            <footer id="footer" className="footer text-center">

                <div className="container footer-top">
                    <div className="row gy-4">
                        <div className="col-lg-12 col-md-12 footer-about">
                            <a href="/" className="logo d-flex align-items-center justify-content-center">
                                <span className="sitename"><img src="assets/img/ppg.png" alt="" srcSet="" /></span>
                            </a>
                            <div className="footer-contact pt-3">
                                <p>Jalan Lapangan Banteng Barat</p>
                                <p>No. 3-4 Jakarta Pusat 10710</p>
                            </div>
                            <div className="social-links d-flex mt-4 justify-content-center">
                                <a rel="noreferrer" target="_blank" href="https://x.com/Kemenag_RI"><i className="bi bi-twitter-x"></i></a>
                                <a rel="noreferrer" target="_blank" href="https://www.facebook.com/KementerianAgamaRI"><i className="bi bi-facebook"></i></a>
                                <a rel="noreferrer" target="_blank" href="https://www.instagram.com/kemenag_ri/#"><i className="bi bi-instagram"></i></a>
                                <a rel="noreferrer" target="_blank" href="https://www.youtube.com/channel/UCg8r6lAzXP9OCyR0G1uBewg"><i className="bi bi-youtube"></i></a>
                                <a rel="noreferrer" target="_blank" href="https://www.tiktok.com/@kemenag_ri"><i className="bi bi-tiktok"></i></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container copyright text-center mt-4">
                    <p>© <span>Copyright</span> <strong className="px-1 sitename">Kementerian Agama RI</strong> <span>All Rights Reserved</span></p>
                    <div className="credits">
                        Designed by <a href="https://kemenag.go.id/" rel="noreferrer" target="_blank">Pusdatin Kemenag RI</a>
                    </div>
                </div>

            </footer>
        </div>
    )
}
export default LandingPage